<button class="btn btn-primary btn-follow-unlock" [ngClass]="{'btn-block': isBlock}" (click)="follow()">
  <i class="fa fa-unlock"></i> Follow to Unlock {{label}}
</button>
